export function formatFileSize(bytes: number, decimalPoint: number, withUnit = true) {
  if (bytes == 0) return '0 Bytes';
  let k = 1000;
    var dm = decimalPoint || 2;
    var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
  if (withUnit) {
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
}
